<template>
  <el-dialog :visible="visible" :title="isFail ? '一键入库结果' : '一键入库确认'" @close="close" top="5vh" width="1400px">
    <div class="instock-confirm-dialog">
      <h3 v-if="isFail">以下库存导入失败，请更改导入数量重新入库或结束导入</h3>
      <WmsTable :columns="columns" :isPagination="false" :hasHeader="false" :dataSource="dataSource"
        rowKey="platformOrderNo" :scrollY="650" style="height:700px">
        <div slot-scope="{text}" slot="productImg">
          <ImgView :src="text" :width="40" :height="40"/>
        </div>
        <div slot="realImportNum" slot-scope="{text,record}">
          <el-input @input="changeInput(record)" v-model="record.realImportNum"
            :class="{ warn: record.importNum > record.mabangNum }"></el-input>
        </div>
        <div slot="productName" slot-scope="{text,record}">

          <el-tooltip class="item" effect="dark" :content="text" placement="top-start">
            <template #content>
              <div style="width:200px;">
                {{ text }}
              </div>
            </template>
            <div class="tooltip">{{ text }}</div>
          </el-tooltip>
        </div>
      </WmsTable>
      <div class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button @click="overStock" v-if="isFail">结束</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import { inboundOrderConfirmApi, finishOrderCompleteApi } from '@/apis/inHouse'
export default {
  name: "InterBtnBox",
  components: { WmsTable, ImgView },
  data() {
    return {
      columns: [
        {
          title: "图片",
          key: "productImg",
          dataIndex: "productImg",
          rowKey: "key",
          width:70,
          scopedSlots: {
            customRender: "productImg",
          },
        },
        {
          title: "SKU",
          key: "productSku",
          dataIndex: "productSku",
          rowKey: "key",
        },
        {
          title: "商品名",
          key: "productName",
          dataIndex: "productName",
          rowKey: "key",
          scopedSlots: {
            customRender: "productName",
          },
        },
        {
          title: "商品规格",
          key: "productProp",
          dataIndex: "productProp",
          rowKey: "key",
        },
        {
          title: "马帮SKU",
          key: "thirdProductSku",
          dataIndex: "thirdProductSku",
          rowKey: "key",
        },
        {
          title: "导入库存数",
          key: "importNum",
          dataIndex: "importNum",
          rowKey: "key",
          width:120
        },
        {
          title: "马帮库存数",
          key: "mabangNum",
          dataIndex: "mabangNum",
          rowKey: "key",
          width:120
        },
        {
          title: "导入数量",
          key: "realImportNum",
          dataIndex: "realImportNum",
          rowKey: "key",
          width:120,
          scopedSlots: {
            customRender: "realImportNum",
          },
        },
        {
          title: "库位",
          key: "gridCode",
          dataIndex: "gridCode",
          rowKey: "key",
          width:120
        },
      ],
      visible: false,
      dataSource: [],
      itemDetail: {},
      isFail: false
    };
  },
  computed: {
  },
  methods: {
    close() {
      this.visible = false
    },
    open(record, data) {
      this.isFail = false
      this.dataSource = data.map((item) => {
        return {
          ...item,
          realImportNum: item.importNum < item.mabangNum ? item.importNum : item.mabangNum
        }
      })
      this.itemDetail = record
      this.visible = true
    },
    changeInput(record) {
      record.realImportNum =
        (record.realImportNum.match(/\d+/) &&
          record.realImportNum.match(/\d+/)[0]) ||
        "";
    },
    submit() {
      inboundOrderConfirmApi({
        inboundCode: this.itemDetail.inboundCode,
        itemList: this.dataSource.map((item) => {
          return {
            inboundItemId: item.id,
            realImportNum: item.realImportNum,
            thirdProductSku: item.thirdProductSku
          }
        })
      }).then((res) => {
        if (res.data.length === 0) {
          this.$message.success('操作成功！')
          this.$emit('refresh')
          this.close()
          return
        }
        this.isFail = true
        this.dataSource = res.data.map((item) => {
          return {
            ...item,
            realImportNum: item.realImportNum
          }
        })

      })
    },
    overStock() {
      this.$confirm('是否结束？', "提示", {
        confirmButtonText: "确认",
        type: "error",
        cancelButtonText: "取消",
      }).then(() => {
        finishOrderCompleteApi({
          inboundCode: this.itemDetail.inboundCode
        }).then(() => {
          this.$emit('refresh')
          this.close()
        })
      });
    }
  },
};
</script>

<style lang="less">
.instock-confirm-dialog {
  .dialogTitle {
    height: 60px;
    width: 100%;
    font-size: 20px;
    text-align: center;
    line-height: 60px;
    background-color: #00284d;
    color: #e8e8e8;
  }

  .dialog-footer {
    text-align: right;
    padding: 20px 0;
  }

  .warn {
    .el-input__inner {
      border: 1px solid red;
      background: rgb(255, 244, 244);
    }
  }

  .tooltip {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
